// extracted by mini-css-extract-plugin
module.exports =  {"tc-add-facet-popover":"AddFacetPopover-module__tc-add-facet-popover___TuKb2","tc-add-facet-popover-items":"AddFacetPopover-module__tc-add-facet-popover-items___N9pWV"};